import { makeCone } from "@graphic/utils";
import { useThree } from "@react-three/fiber";
import { useEffect, useRef } from "react";

export const useCreateCone = (displayCone: boolean) => {
  const get = useThree(state => state.get);

  const coneRef = useRef<THREE.Mesh>();

  useEffect(() => {
    if (!displayCone) return;

    const radius = 1000;
    const height = 1000;
    const color = 0xffff00;
    const opacity = 0.4;

    const cone = makeCone(radius, height, color, opacity);

    cone.rotateX(-Math.PI / 2);
    cone.translateY(-height / 2);
    coneRef.current = cone;

    return () => {
      const scene = get().scene;
      scene.remove(coneRef.current);
    };
  }, [displayCone]);

  return coneRef;
};
